import React from "react";

const ArcanaTables = ({ results }) => {
  return (
    <div className="flex flex-col gap-8 w-full">

      {/* Summary Card */}
      <div className="card">
        <h2 className="title text-blue-700">Число судьбы: {results.lifePath}</h2>
        <h2 className="title text-gray-700 text-lg sm:text-xl">Возраст: {results.age}</h2>
      </div>

      {/* Core Numbers Table */}
      <div className="card overflow-x-auto">
        <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-800">Основные числа</h3>
        <table className="min-w-full border-collapse text-center">
          <thead>
            <tr className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
              <th className="border px-2 py-2">Путь</th>
              <th className="border px-2 py-2">Число Достижений (ЧД)</th>
              <th className="border px-2 py-2">Кармический Узел (КУ)</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {[0, 1, 2, 3].map((i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="border px-2 py-2 font-medium">
                  {i === 0 && <>Аркан дня: <span className="font-bold">{results.dayArcana}</span></>}
                  {i === 1 && <>Аркан месяца: <span className="font-bold">{results.monthArcana}</span></>}
                  {i === 2 && <>Аркан года: <span className="font-bold">{results.yearArcana}</span></>}
                  {i === 3 && <>Самореализация: <span className="font-bold">{results.selfRealization}</span></>}
                </td>
                <td className="border px-2 py-2 font-semibold">{results.achievements[i]}</td>
                <td className="border px-2 py-2 font-semibold">{results.karmicKnots[i]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Life Periods Table */}
      <div className="card overflow-x-auto">
        <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-800">Периоды жизни</h3>
        <table className="min-w-full border-collapse text-center">
          <thead>
            <tr className="bg-gradient-to-r from-green-400 to-teal-500 text-white">
              <th className="border px-2 py-2">Период</th>
              <th className="border px-2 py-2">Возрастной диапазон</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {[0, 1, 2, 3].map((i) => {
              const inPeriod =
                (i === 0 && results.age < results.periods[0]) ||
                (i === 1 && results.age >= results.periods[0] && results.age < results.periods[1]) ||
                (i === 2 && results.age >= results.periods[1] && results.age < results.periods[2]) ||
                (i === 3 && results.age >= results.periods[2]);

              const periodRange =
                i === 0
                  ? `0 – ${results.periods[0]}`
                  : i === 3
                  ? `${results.periods[2]} – до конца жизни`
                  : `${results.periods[i - 1]} – ${results.periods[i]}`;

              return (
                <tr
                  key={i}
                  className={`${inPeriod ? "bg-green-100 font-bold" : ""} hover:bg-gray-50`}
                >
                  <td className="border px-2 py-2 font-medium">Период {i + 1}</td>
                  <td className="border px-2 py-2">{periodRange}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ArcanaTables;